export const NEW_USER_EXPERIMENT_AGE_IN_DAYS = 14;

export enum FilterMode {
  Files = 'FILES',
  Code = 'CODE',
}
